/**
 * Tracks whether the host application is running in PSP (Public Service Platform)
 * mode.
 *
 * The host app is responsible for calling `setPspMode(true)` during PSP
 * bootstrap (e.g. in the PSP entry's `mount`) and `setPspMode(false)` on
 * teardown so that subsequent standalone runs are unaffected.
 */
let pspModeEnabled = false;

export function setPspMode(enabled: boolean): void {
  pspModeEnabled = enabled;
}

export function isPspMode(): boolean {
  return pspModeEnabled;
}
